import styled from 'styled-components';

export const Plate = styled.div`
  border-radius: 20px;
  background: #f4f5f6;
  box-shadow: 0px 2px 4px 0px #394e7f33;
`;

export const TitleDatesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
`;

export const CardDates = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #9965f4;
`;

export const CardDescription = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
`;

export const CardTitleIcon = styled.img`
  width: 30px;
  height: 30px;
`;

export const CardHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CardBodyWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
